<template>
    <div>
        <label class="block" v-if="!file">
            <span class="sr-only">{{ this.title }}</span>
            <input @change="saveFileFromForm" type="file" class="block w-full text-sm text-gray-500
      file:me-4 file:py-2 file:px-4
      file:rounded-lg file:border-0
      file:text-sm file:font-semibold
      file:bg-blue-600 file:text-white
      hover:file:bg-blue-700
      file:disabled:opacity-50 file:disabled:pointer-events-none
      dark:file:bg-blue-500
      dark:hover:file:bg-blue-400
    ">
        </label>
        <div v-else class="flex items-center">
            <div class="mr-2">
                {{ this.file.title }}
            </div>
            <div class="cursor-pointer" @click="deleteFileHandler">
                <XCircleIcon class="'text-purple-400 hover:text-purple-500 mr-4 flex-shrink-0 h-4 w-4"
                             aria-hidden="true"/>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions} from "pinia";
import {useStorage} from "@/scripts/store/storage";
import {FileType} from "@/scripts/api/storage";
import {XCircleIcon} from '@heroicons/vue/24/outline'

export default {
    components: {
        XCircleIcon
    },

    props: {
        title: {
            default: 'Загрузить файл'
        },
        fileId: {
            default: null
        },
        replaceOnly: {
            default: true
        },
        type: {
            required: true,
        },
        loadUntouched: {
            default: true
        }
    },

    data() {
        return {
            file: null,
            oldFile: null,
        }
    },

    async mounted() {
        if (this.fileId) {
            this.file = await this.getFile(this.fileId)
        } else {
            if (this.loadUntouched) {
                this.file = await this.getUnattachedFile(this.type)
            }
        }

        if (this.file) {
            this.$emit('change', this.file);
        }
    },

    methods: {
        ...mapActions(useStorage, ['saveFile', 'deleteFile', 'getUnattachedFile', 'getFile']),

        async saveFileFromForm(event) {
            this.file = await this.saveFile(event.target.files[0], this.type)
            this.$emit('change', this.file);

            if (this.replaceOnly && this.oldFile) {
                await this.deleteFile(this.oldFile)
            }
        },

        async deleteFileHandler() {
            if (!this.replaceOnly) {
                await this.deleteFile(this.file)
            } else {
                this.oldFile = this.file
            }

            this.file = null
            this.$emit('change', null);
        }
    }
}
</script>